import { Button } from "@headlessui/react";
import { CSSProperties, ElementType } from "react";

export const BorderedButton = ({
  children,
  className,
  onClick,
  disabled,
  style,
  as,
  "data-testid": dataTestId,
  ...otherProps
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  style?: CSSProperties;
  disabled?: boolean;
  as?: ElementType;
  "data-testid"?: string;
  [key: string]: any;
}) => {
  const Component = as || Button;

  return (
    <Component
      data-testid={dataTestId}
      className={`flex flex-1 items-center py-2 px-8 bg-white text-blue-700 rounded-[8px] border-[1px] border-blue-700 
        data-[hover]:brightness-125 data-[active]:brightness-125 
        hover:brightness-125 active:brightness-125 
        ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Component>
  );
};
